import { ListState } from '@react-stately/list';
import React from 'react';

interface ListBoxContextValue {
  state: ListState<unknown>;
  shouldUseVirtualFocus: boolean;
  disableSelectedStyles: boolean;
  containerWidth?: number;
  constrainWidth: boolean;
}

export const ListBoxContext = React.createContext<ListBoxContextValue | null>(
  null
);
